"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoLayoutApi = exports.DeepPCBMetadataSchema = exports.DeepPCBActionMetadataSchema = exports.DeepPCBProjectMetadataSchema = exports.CheckBoardRequestBodySchema = exports.ApplyAutoLayoutJobBodySchema = exports.ApplyAutoLayoutJobRequestBodySchema = exports.DiscardAutoLayoutJobBodySchema = exports.DiscardAutoLayoutJobRequestBodySchema = exports.ResumeAutoLayoutJobBodySchema = exports.ResumeAutoLayoutJobRequestBodySchema = exports.PauseAutoLayoutJobBodySchema = exports.PauseAutoLayoutJobRequestBodySchema = exports.ConfirmAutoLayoutJobBodySchema = exports.ConfirmAutoLayoutJobRequestBodySchema = exports.SubmitAutoLayoutJobBodySchema = exports.SubmitAutoLayoutJobRequestBodySchema = exports.AutoLayoutJobConfiguration = exports.ConvergenceCriteria = exports.ConvergenceCriteriaTypeEnum = exports.autoLayoutResponseFilter = exports.autoLayoutExistingWiring = exports.autoLayoutRequestAccount = exports.BaseAutoLayoutJobRequestBodySchema = exports.AutoLayoutApiStructure = void 0;
const zod_1 = require("zod");
const backendProxy_1 = require("../backendProxy");
const identifier_1 = require("../identifier");
const identifiers_1 = require("./identifiers");
const Action = zod_1.z.enum(["create", "submit", "confirm", "pause", "resume", "discard", "apply", "track"]);
const Paths = zod_1.z.object(Action.options.reduce((acc, key) => {
    acc[key] = zod_1.z.string();
    return acc;
}, {}));
const VersionDefinition = zod_1.z
    .object({
    paths: Paths,
})
    .strict();
const Version = zod_1.z.enum(["v1"]);
const Versions = zod_1.z.object(Version.options.reduce((acc, key) => {
    acc[key] = VersionDefinition;
    return acc;
}, {}));
exports.AutoLayoutApiStructure = Versions.parse({
    v1: {
        paths: {
            create: "/auto-layout/job/create",
            submit: "/auto-layout/job/submit",
            confirm: "/auto-layout/job/confirm",
            pause: "/auto-layout/job/pause",
            resume: "/auto-layout/job/resume",
            discard: "/auto-layout/job/discard",
            apply: "/auto-layout/job/apply",
            track: "/auto-layout/job/track",
        },
    },
});
const urlFor = (name, version) => backendProxy_1.AutoLayout.resolve(exports.AutoLayoutApiStructure[version].paths[name]);
exports.BaseAutoLayoutJobRequestBodySchema = zod_1.z.object({
    userUid: identifier_1.UserUid,
    jobUid: identifiers_1.autoLayoutJobUidSchema,
    organizationUid: identifier_1.optionalOrganizationUid,
});
var autoLayoutRequestAccount;
(function (autoLayoutRequestAccount) {
    autoLayoutRequestAccount["production"] = "production";
    autoLayoutRequestAccount["testing"] = "testing";
})(autoLayoutRequestAccount || (exports.autoLayoutRequestAccount = autoLayoutRequestAccount = {}));
var autoLayoutExistingWiring;
(function (autoLayoutExistingWiring) {
    autoLayoutExistingWiring["clear"] = "clear";
    autoLayoutExistingWiring["protect"] = "protect";
    autoLayoutExistingWiring["mutable"] = "mutable";
})(autoLayoutExistingWiring || (exports.autoLayoutExistingWiring = autoLayoutExistingWiring = {}));
var autoLayoutResponseFilter;
(function (autoLayoutResponseFilter) {
    autoLayoutResponseFilter["fullBoard"] = "fullBoard";
    autoLayoutResponseFilter["wiresOnly"] = "wiresOnly";
})(autoLayoutResponseFilter || (exports.autoLayoutResponseFilter = autoLayoutResponseFilter = {}));
exports.ConvergenceCriteriaTypeEnum = zod_1.z.enum([
    "IterationsSinceLastCommitted",
    "MinutesSinceLastCommitted",
    "ModelDecidedConvergence",
]);
/**
 * Scoring mode for convergence criteria.
 * - "mark": Record the convergence event only (no control action)
 * - "mark_and_control": Record the event AND halt/control the job (default)
 * - "control": @deprecated Use "mark_and_control" instead. Kept for historical deserialization only.
 */
const ConvergenceScoringMode = zod_1.z.enum(["control", "mark", "mark_and_control"]);
/**
 * Shared scoring configuration for convergence criteria.
 * Defaults to mark_and_control mode when omitted.
 */
const ConvergenceScoring = zod_1.z.object({
    mode: ConvergenceScoringMode.default("mark_and_control"),
    scoreValue: zod_1.z.number().nonnegative().optional(),
});
const ConvergenceCriteriaBase = zod_1.z.object({
    type: exports.ConvergenceCriteriaTypeEnum,
});
exports.ConvergenceCriteria = zod_1.z.discriminatedUnion("type", [
    zod_1.z
        .object({
        ...ConvergenceCriteriaBase.shape,
        type: zod_1.z.literal(exports.ConvergenceCriteriaTypeEnum.enum.IterationsSinceLastCommitted),
        threshold: zod_1.z.number().int().nonnegative(),
        scoring: ConvergenceScoring.default({}),
    })
        .passthrough(),
    zod_1.z
        .object({
        ...ConvergenceCriteriaBase.shape,
        type: zod_1.z.literal(exports.ConvergenceCriteriaTypeEnum.enum.MinutesSinceLastCommitted),
        threshold: zod_1.z.number().nonnegative(),
        scoring: ConvergenceScoring.default({}),
    })
        .passthrough(),
    zod_1.z
        .object({
        ...ConvergenceCriteriaBase.shape,
        type: zod_1.z.literal(exports.ConvergenceCriteriaTypeEnum.enum.ModelDecidedConvergence),
        scoring: ConvergenceScoring.default({}),
        recordingMode: zod_1.z.enum(["first_seen", "all_events", "all_deduped_events"]).default("first_seen"),
        capturePayloadProperties: zod_1.z.array(zod_1.z.string()).optional(),
    })
        .passthrough(),
]);
// Specific schemas extending the base schema
exports.AutoLayoutJobConfiguration = zod_1.z.object({
    existingWiring: zod_1.z.nativeEnum(autoLayoutExistingWiring).default(autoLayoutExistingWiring.protect),
    responseFilter: zod_1.z.nativeEnum(autoLayoutResponseFilter).default(autoLayoutResponseFilter.fullBoard),
    externalApiEnv: zod_1.z.nativeEnum(autoLayoutRequestAccount).default(autoLayoutRequestAccount.production),
    timeoutMinutes: zod_1.z.number().int().nonnegative().default(10),
    maxInactivityWaitTimeoutMinutes: zod_1.z.number().nonnegative().default(5),
    includeRoutingPriority: zod_1.z.boolean().default(false),
    includeNetPreferences: zod_1.z.boolean().default(false),
    protectPolygons: zod_1.z.boolean().default(false),
    useKeepoutRuleForPolygonProtection: zod_1.z.boolean().default(false),
    useExportPerformanceOptimizations: zod_1.z.boolean().default(false),
    version: Version.default("v1").catch("v1"),
    convergence: zod_1.z.array(exports.ConvergenceCriteria).default([
        exports.ConvergenceCriteria.parse({
            type: exports.ConvergenceCriteriaTypeEnum.enum.IterationsSinceLastCommitted,
            threshold: 25,
        }),
    ]),
    pipeline: zod_1.z
        .object({
        callbackHandler: zod_1.z.string().default("{{host}}/autolayout/callback/{{requestId}}"),
        iterationRetrieval: zod_1.z.string().default("{{host}}/proxy?url={{encodeURIComponent sourceUrl}}"),
    })
        .default({}),
});
exports.SubmitAutoLayoutJobRequestBodySchema = zod_1.z.object({
    ...exports.BaseAutoLayoutJobRequestBodySchema.shape,
    inputBoardLocation: zod_1.z.string(),
    projectPath: zod_1.z
        .string()
        .regex(/^[a-z0-9-]+\/[a-z0-9-]+$/)
        .optional(),
});
exports.SubmitAutoLayoutJobBodySchema = {
    body: exports.AutoLayoutJobConfiguration,
};
exports.ConfirmAutoLayoutJobRequestBodySchema = exports.BaseAutoLayoutJobRequestBodySchema;
exports.ConfirmAutoLayoutJobBodySchema = {
    body: exports.ConfirmAutoLayoutJobRequestBodySchema,
};
exports.PauseAutoLayoutJobRequestBodySchema = exports.BaseAutoLayoutJobRequestBodySchema;
exports.PauseAutoLayoutJobBodySchema = {
    body: exports.PauseAutoLayoutJobRequestBodySchema,
};
exports.ResumeAutoLayoutJobRequestBodySchema = exports.BaseAutoLayoutJobRequestBodySchema;
exports.ResumeAutoLayoutJobBodySchema = {
    body: exports.ResumeAutoLayoutJobRequestBodySchema,
};
exports.DiscardAutoLayoutJobRequestBodySchema = exports.BaseAutoLayoutJobRequestBodySchema;
exports.DiscardAutoLayoutJobBodySchema = {
    body: exports.DiscardAutoLayoutJobRequestBodySchema,
};
exports.ApplyAutoLayoutJobRequestBodySchema = zod_1.z.object({
    ...exports.BaseAutoLayoutJobRequestBodySchema.shape,
    iterationIndex: zod_1.z.number().int().nonnegative().optional(),
});
exports.ApplyAutoLayoutJobBodySchema = {
    body: exports.ApplyAutoLayoutJobRequestBodySchema,
};
exports.CheckBoardRequestBodySchema = zod_1.z.object({
    userUid: identifier_1.UserUid,
    jobUid: identifiers_1.autoLayoutJobUidSchema,
    jsonFileUrl: zod_1.z.string().url(),
    externalApiEnv: zod_1.z.nativeEnum(autoLayoutRequestAccount).optional(),
});
exports.DeepPCBProjectMetadataSchema = zod_1.z.object({
    project: zod_1.z.string().regex(/^[a-z0-9-]+\/[a-z0-9-]+$/),
});
exports.DeepPCBActionMetadataSchema = zod_1.z.object({
    action: zod_1.z.enum(["applied", "discarded"]),
    iterationIndex: zod_1.z.number().int().nonnegative().optional(),
});
exports.DeepPCBMetadataSchema = exports.DeepPCBProjectMetadataSchema.or(exports.DeepPCBActionMetadataSchema);
exports.AutoLayoutApi = {
    urlFor,
    versionParse: Version.default("v1").catch("v1").parse,
    version: Version.enum,
    action: Action.enum,
};
//# sourceMappingURL=api.js.map